<template>
  <v-dialog v-model="show" width="600" content-class="popup-wrap-1">
    <div class="pa-8">
      <p class="title-type-4">시간대별 세부 집계</p>

      <div class="white rounded" style="height: 300px">
        <vue-scroll>
          <table class="data-table-1 type-2">
            <caption>
              데이터 테이블
            </caption>
            <colgroup>
              <col width="25%" />
              <col width="25%" />
              <col width="25%" />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th scope="row">시간대 (KST)</th>
                <th scope="row">노출</th>
                <th scope="row">클릭</th>
                <th scope="row">CTR</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th scope="row">총계</th>
                <td>{{ total.impr | comma }}</td>
                <td>{{ total.click | comma }}</td>
                <td>{{ total.ctr ? total.ctr.toFixed(2) + '%' : '-' }}</td>
              </tr>
            </tfoot>
            <tbody>
              <tr v-for="(list, index) in boardLists" :key="index">
                <td>{{ list.hour }}시</td>
                <td>
                  {{ list.impr | comma }}
                </td>
                <td>
                  {{ list.click | comma }}
                </td>
                <td>
                  {{ list.ctr ? list.ctr.toFixed(2) + '%' : '-' }}
                </td>
              </tr>
            </tbody>
          </table>
        </vue-scroll>
      </div>

      <div class="d-flex justify-end mt-6">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click="show = false"
        >
          확인
        </v-btn>
      </div>
    </div>

    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="ok"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </v-dialog>
</template>

<script>
import bus from '@/utils/bus';
import { reportAdminHoursList } from '@/api/report';

import SystemAlert from '~@/modal/SystemAlert.vue';

export default {
  props: {
    value: Boolean,
    campaignId: String,
    medias: Array,
  },
  components: { SystemAlert },
  data: () => ({
    resultType: '',
    logResult: '',
    showSystemAlert: false,
    boardLists: [],
    total: {
      impr: 0,
      click: 0,
      ctr: 0,
    },
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async registerHours(dayId) {
      try {
        const resultData = {
          medias: this.medias,
        };

        const { data } = await reportAdminHoursList(
          this.campaignId,
          dayId,
          resultData,
        );

        if (data.list.length > 0) {
          this.boardLists = data.list[0].hours;

          const total = {
            impr: 0,
            click: 0,
            ctr: 0,
          };
          data.list[0].hours.forEach(da => {
            total.impr = total.impr + da.impr;
            total.click = total.click + da.click;
          });
          total.ctr = (total.click / total.impr) * 100;
          this.total = total;
        } else {
          this.showSystemAlert = true;
          this.logResult = '조회된 목록이 없습니다.';
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    ok() {
      this.show = false;
    },
  },
  mounted() {},
};
</script>
